import { useState } from "react";
import { useFormContext } from "react-hook-form";

import FormFileContentField from "components/Environment/components/FormItems/FileContentField";
import FormFileUploadField from "components/Environment/components/FormItems/FileUploadField";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Tab from "ds/components/Tab";
import TabPanel from "ds/components/TabPanel";
import CardTitle from "ds/components/Card/components/Title";

import styles from "./styles.module.css";
import { ContextMountedFileFormFields, FileMountDrawerTabs } from "./types";

type ContextMountedFilesDraftFormProps = {
  onCancel?: () => void;
};

const ContextMountedFilesDraftForm = ({ onCancel }: ContextMountedFilesDraftFormProps) => {
  const [currentTab, setCurrentTab] = useState(FileMountDrawerTabs.Upload);

  const builderForm = useFormContext<ContextMountedFileFormFields>();

  const {
    watch,
    formState: { isValid, isSubmitting },
  } = builderForm;

  const isUploadTab = currentTab === FileMountDrawerTabs.Upload;
  const isManuallyAddTab = currentTab === FileMountDrawerTabs.AddManually;

  const content = watch("fileBody");
  return (
    <Box className={styles.fileWrapper} direction="column">
      <Box justify="between" fullWidth padding="large" align="center" direction="column">
        <Box justify="between" fullWidth align="center">
          <CardTitle tag="span" variant="p-t7">
            File
          </CardTitle>
          <Box gap="medium">
            <Button variant="secondary" size="small" onPress={onCancel} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              size="small"
              disabled={!isValid}
              loading={isSubmitting}
            >
              Save
            </Button>
          </Box>
        </Box>

        <Box direction="row" gap="medium" fullWidth padding="large 0 0 0" role="tablist">
          <Tab
            onClick={setCurrentTab}
            isActive={isUploadTab}
            id={FileMountDrawerTabs.Upload}
            label="Upload"
          />
          <Tab
            onClick={setCurrentTab}
            isActive={isManuallyAddTab}
            id={FileMountDrawerTabs.AddManually}
            label="Add manually"
          />
        </Box>
      </Box>
      <Box
        padding={isUploadTab ? "large" : "0"}
        className={styles.file}
        align="stretch"
        justify="stretch"
        direction="column"
      >
        <TabPanel isActive={isUploadTab} id={FileMountDrawerTabs.Upload}>
          <FormFileUploadField name="file" required={!content} className={styles.fileField} />
        </TabPanel>
        <TabPanel isActive={isManuallyAddTab} id={FileMountDrawerTabs.AddManually}>
          <FormFileContentField name="fileBody" className={styles.variablePreviewEditor} />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ContextMountedFilesDraftForm;
